<template>
    <b-list-group-item v-if="issue" class="issue">
        <div class="issue-main-info">
            <b-link
                v-if="value.project_id"
                :to="{name: 'projects.issues.show', params: { projectId: issue.project_id, id: issue.id} }"
                class="font-weight-bold d-block"
            >
                {{ issue.title }}
            </b-link>

            <b-link
                v-else
                :to="{name: 'issues.show', params: {id: issue.id} }"
                class="font-weight-bold d-block"
            >
                {{ issue.title }}
            </b-link>
            <span class="text-muted">
                    <template v-if="issue.project">
                        {{ issue.project.name }} -
                    </template>

                     {{ $t('Created at: :date', {date: $moment(issue.created_at).format('lll')}) }}
                </span>
        </div>

        <div class="issue-meta">
            <div>
                <b-button
                    v-if="issue.group"
                    v-b-tooltip.html="issue.group.name"
                    variant="default"
                >
                    <fa icon="users" />
                </b-button>

                <b-button
                    v-if="issue.responsible_users && issue.responsible_users.length"
                    v-b-tooltip.html="issue.responsible_users.map(user => user.name).join('<br>')"
                    variant="default"
                >
                    <fa icon="user-tie" />
                </b-button>

                <span class="p-2">
                        <fa icon="comments" />
                         {{ issue.messages_count }}
                    </span>
            </div>
            <div class="text-muted">
                {{ $t('Last update: :date', {date: $moment(issue.updated_at).format('lll')}) }}
            </div>
        </div>
    </b-list-group-item>
</template>
<script>
    import {cloneDeep} from 'lodash'

    export default {
        name: 'IssuesListItem',
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                issue: null
            }
        },
        watch: {
            value: {
                handler(newValue) {
                    this.issue = cloneDeep(newValue);
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.$echo.channel(`issue.${this.value.id}`)
                .listen('IssueResolved', ({issue}) => {
                    this.issue.resolved_at = issue.resolved_at;
                });

        },
    }
</script>

<style scoped>
    .issue {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
    }

    .issue-meta {
        text-align: right;
    }

    .issue-main-info,
    .issue-meta {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
</style>
